import type { HomeGlobalStore } from '../../../../types'

const findElementIndex = (child: HTMLElement, childClass: string): number => {
  const parent = child?.parentNode?.querySelectorAll(childClass);
  const index = Array.from(
    parent as NodeListOf<HTMLDivElement>
  ).indexOf(child as HTMLDivElement);
  return index;
}

const getBreakpoint = () => {
  const breakpoint = window.matchMedia("(max-width: 767px)");
  return (breakpoint.matches) ? 'mobile' : 'desktop';
}

const getOffset = (el: HTMLElement) => {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
}

const globalStore: HomeGlobalStore = {
  ['getAbsoluteOffset'](element: HTMLElement) {
    if (!element) return;
    let top = 0, left = 0;
    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent as HTMLElement;
    } while (element);

    return {
      y: top,
      x: left,
    };
  },
  breakpoint: getBreakpoint(),
  playMusic: false
}

let lang: any;
if (document.querySelector('html')?.getAttribute('lang') == 'tc' || document.querySelector('html')?.getAttribute('lang') == 'sc') {
  lang = document.querySelector('html')?.getAttribute('lang');
} else {
  lang = 'en';
}

let menuitemHomeLabel = { 'en': 'Halloween Fest', 'tc': '哈囉喂全園祭', 'sc': '哈啰喂全园祭' };

let menuitemHomeUrl = '/' + lang + '/park-experience/halloween-fest-2025';

let houseMenuTitle = { 'en': 'More Night Haunted Experience', 'tc': '更多夜間驚嚇體驗', 'sc': '更多夜间惊吓体验' };
let houseMenuArray = [
  {
    "en": "The Hatred Box",
    "tc": "怨靈盲盒",
    "sc": "怨灵盲盒",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/the-hatred-box",
    "class": "house1 combo1",
    "img": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house1.png",
    "imghover": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house1-hover.png"
  },
  {
    "en": "The Ritual Mansion",
    "tc": "詭宅獻祭",
    "sc": "诡宅献祭",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/the-ritual-mansion",
    "class": "house2 combo1",
    "img": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house2.png",
    "imghover": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house2-hover.png"
  },
  {
    "en": "The Cannibal Woods",
    "tc": "喰人之森",
    "sc": "喰人之森",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/the-cannibal-woods",
    "class": "house3 combo1",
    "img": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house3.png",
    "imghover": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house3-hover.png"
  },
  {
    "en": "The Unsolved Terrors",
    "tc": "港詭奇案",
    "sc": "港诡奇案",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/the-unsolved-terrors",
    "class": "house4 combo2",
    "img": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house4.png",
    "imghover": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house4-hover.png"
  },
  {
    "en": "H25: Rising Fear",
    "tc": "H25．慄",
    "sc": "H25．栗",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/h25-rising-fear",
    "class": "house5 combo2",
    "img": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house5.png",
    "imghover": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house5-hover.png"
  },
  {
    "en": "The Soul Graveyard",
    "tc": "噬魂墓地",
    "sc": "噬魂墓地",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/the-soul-graveyard",
    "class": "house6 combo2",
    "img": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house6.png",
    "imghover": "https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/menu/menu-house6-hover.png"
  }
];
let otherMenuArray = [
  {
    "en": "Ten Incredible and Creepy Performances",
    "tc": "十大嘩鬼匯演",
    "sc": "十大怪趣汇演",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/ten-incredible-and-creepy-performances"
  },
  {
    "en": "Check-in Spots and Family-friendly Activities",
    "tc": "打卡位及合家歡活動",
    "sc": "打卡位及合家欢活动",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/check-in-spots-and-family-friendly-activities"
  },
  {
    "en": "Day of the Dead Immersive Experience",
    "tc": "深入亡靈節體驗",
    "sc": "深入亡灵节体验",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/day-of-the-dead-immersive-experience"
  },
  {
    "en": "Limited-Time Halloween Event",
    "tc": "期間限定活動",
    "sc": "期间限定活动",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/limited-time-halloween-event"
  },
  {
    "en": "Spookily Fun and Great Deals",
    "tc": "鬼咁好玩好買",
    "sc": "鬼趣好玩乐购",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/spookily-fun-and-great-deals"
  },
  {
    "en": "Diabolically Delightful Halloween Temptations",
    "tc": "哈囉喂主題「瘋魅」美食",
    "sc": "哈啰喂主题＂疯魅＂美食",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/diabolically-delightful-halloween-temptations"
  }
];
let othersMenuArray = [
  {
    "en": "主題美食",
    "tc": "主題美食",
    "sc": "主題美食",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/index"
  },
  {
    "en": "遊戲攤位",
    "tc": "遊戲攤位",
    "sc": "遊戲攤位",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/night-experience"
  },
  {
    "en": "其他活動",
    "tc": "其他活動",
    "sc": "其他活動",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/day-experience"
  }
];

let mainMenu = [
  {
    "en": "Homepage",
    "tc": "首頁",
    "sc": "首页",
    "link": "/" + lang + "/park-experience/halloween-fest-2025"
  },
  {
    "en": "Night Experience",
    "tc": "夜間體驗",
    "sc": "夜间体验",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/the-hatred-box",
    "subMenu": "hauntedOpen",
    "menu": houseMenuArray
  },
  {
    "en": "Other Exciting Experience",
    "tc": "其他精彩活動",
    "sc": "其他精彩活动",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/ten-incredible-and-creepy-performances",
    "subMenu": "otherOpen",
    "menu": otherMenuArray
  },
  // {
  //   "en":"Family", 
  //   "tc":"家庭區域", 
  //   "sc":"家庭区域",
  //   "link":"/" + lang + "/park-experience/halloween-fest-2025/family",
  //   "subMenu": "othersOpen",
  // 	"menu":othersMenuArray
  // },
  {
    "en": "Tickets & Calendar",
    "tc": "門票及活動日期",
    "sc": "门票及活动日期",
    "link": "/" + lang + "/park-experience/halloween-fest-2025/tickets-and-calendar"
  }
];

let ticketLabel = {
  'walled': {
    'en': 'Walled Trio Combo Ticket',
    'tc': '「圍城三館：城寨 · 酒店 · 凶宅」門票',
    'sc': '＂围城三馆：城寨 · 酒店 · 凶宅＂门票'
  },
  'ghostly': {
    'en': 'Ghostly Trio Combo Ticket',
    'tc': '「厲鬼三煞：冥婚 · 監獄 · 禁地」門票',
    'sc': '＂厉鬼三煞：冥婚 · 监狱 · 禁地＂门票'
  },
}

var buyLabel = { 'en': 'BUY TICKET', 'tc': '購買門票', 'sc': '购买门票' };
var buyLabelText = buyLabel[lang] || buyLabel['en'];

var countdownLabel = { 'en': 'Days until Halloween Fest unboxing', 'tc': '距離哈囉喂開箱', 'sc': '距离哈啰喂开箱' };
var countdownLabelText = countdownLabel[lang] || countdownLabel['en'];

var dayLabel = { 'en': '&nbsp;days', 'tc': '天', 'sc': '天' };
var dayLabelText = dayLabel[lang] || dayLabel['en'];

var adLabel = { 'en': 'ADMISSION TICKET', 'tc': '標準入場門票', 'sc': '标准入场门票' };
var adLabelText = adLabel[lang] || adLabel['en'];
var ad_url_array = {
  'en': 'https://bestunion.queue-it.net/?c=bestunion&e=ocpb2c2020&t=https://ticketing.oceanpark.com.hk/oceanpark_b2c/ticketselection.html?selectedCategory=TICKETPACK&eventCode=B2C/B2B&locale=en_GB',
  'tc': 'https://bestunion.queue-it.net/?c=bestunion&e=ocpb2c2020&t=https://ticketing.oceanpark.com.hk/oceanpark_b2c/ticketselection.html?selectedCategory=TICKETPACK&eventCode=B2C/B2B&locale=zh_TW',
  'sc': 'https://bestunion.queue-it.net/?c=bestunion&e=ocpb2c2020&t=https://ticketing.oceanpark.com.hk/oceanpark_b2c/ticketselection.html?selectedCategory=TICKETPACK&eventCode=B2C/B2B&locale=zh_CN'
};
var ad_url = ad_url_array[lang] || ad_url_array['en'];

var comboLabel = { 'en': 'HALLOWEEN COMBO TICKET', 'tc': '哈囉喂景點組合門票', 'sc': '哈啰喂景点组合门票' };
var comboLabelText = comboLabel[lang] || comboLabel['en'];
var combo_url_array = {
  'en': 'https://bestunion.queue-it.net/?c=bestunion&e=ocpb2c2020&t=https://ticketing.oceanpark.com.hk/oceanpark_b2c/ticketselection.html?selectedCategory=SPECIALOFF&eventCode=HW002&locale=en_GB',
  'tc': 'https://bestunion.queue-it.net/?c=bestunion&e=ocpb2c2020&t=https://ticketing.oceanpark.com.hk/oceanpark_b2c/ticketselection.html?selectedCategory=SPECIALOFF&eventCode=HW002&locale=zh_TW',
  'sc': 'https://bestunion.queue-it.net/?c=bestunion&e=ocpb2c2020&t=https://ticketing.oceanpark.com.hk/oceanpark_b2c/ticketselection.html?selectedCategory=SPECIALOFF&eventCode=HW002&locale=zh_CN'
};
var combo_url = combo_url_array[lang] || combo_url_array['en'];

var memberLabel = { 'en': 'MEMBERS PURCHASE', 'tc': '會員購票', 'sc': '会员购票' };
var memberLabelText = memberLabel[lang] || memberLabel['en'];
var member_url_array = {
  'en': 'https://bestunion.queue-it.net/?c=bestunion&e=ocpb2c2020&t=https://ticketing.oceanpark.com.hk/oceanpark_b2c/sfticketselection.html?selectedCategory=SPECIALOFF&eventCode=HW002&locale=en_GB',
  'tc': 'https://bestunion.queue-it.net/?c=bestunion&e=ocpb2c2020&t=https://ticketing.oceanpark.com.hk/oceanpark_b2c/sfticketselection.html?selectedCategory=SPECIALOFF&eventCode=HW002&locale=zh_TW',
  'sc': 'https://bestunion.queue-it.net/?c=bestunion&e=ocpb2c2020&t=https://ticketing.oceanpark.com.hk/oceanpark_b2c/sfticketselection.html?selectedCategory=SPECIALOFF&eventCode=HW002&locale=zh_CN'
};
var member_url = member_url_array[lang] || member_url_array['en'];

const createPanel = () => {
  let container = document.querySelector('.halloween-2025-main-container');

  //Panel Top left
  let panelTL = document.createElement('div');
  panelTL.className = `halloween-2025-panel-tl`;
  container?.appendChild(panelTL);

  let panelTLA = document.createElement('a');
  panelTLA.href = menuitemHomeUrl;
  panelTL.appendChild(panelTLA);

  let panelTLLogo = document.createElement('img');
  panelTLLogo.src = `https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/common/logo-halloween2025-${lang}.png`;
  panelTLLogo.alt = `${menuitemHomeLabel[lang]}`;
  panelTLA.appendChild(panelTLLogo);

  //Panel Bottom
  if (!document.querySelector('.halloween-2025-index-phase-1')) {

    let panelB = document.createElement('div');
    panelB.className = `halloween-2025-panel-b`;
    panelB.setAttribute('x-bind', `halloweenMainNav`);
    panelB.setAttribute('x-data', `{hauntedOpen:false,otherOpen:false,othersOpen:false}`);

    container?.appendChild(panelB);

    let panelBMainmenu = document.createElement('div');
    panelBMainmenu.className = `halloween-2025-panel-mainmenu`;
    panelB.appendChild(panelBMainmenu);

    mainMenu.forEach((ele: any) => {
      let div = document.createElement('div');
      div.className = 'halloween-2025-panel-mainmenu-tab';
      panelBMainmenu.appendChild(div);
      let a = document.createElement('a');
      a.href = ele.link;
      // a.setAttribute('@click','hauntedOpen=true');
      div.appendChild(a);

      if (ele.subMenu) {
        a.innerHTML = `
        <span
        @mouseover="${ele.subMenu}=true" 
        @mouseout="${ele.subMenu}=false"
        >${ele[lang]}
        </span>
        `;
      } else {
        a.innerHTML = `<span>${ele[lang]}</span>`;
      }
      if (ele?.menu) {
        let submenuBtn = document.createElement('button');
        submenuBtn.className = 'halloween-2025-panel-mainmenu-tab-sub-btn';
        div.appendChild(submenuBtn);

        submenuBtn.addEventListener('click', () => {
          div.classList.toggle("open-sub-2024");
        })

        let submenu = document.createElement('div');
        submenu.className = `halloween-2025-panel-mainmenu-tab-sub 
        item-count-${ele.menu.length}`
        div.appendChild(submenu);
        ele.menu.forEach((sm: any) => {
          let sa = document.createElement('a');
          sa.href = sm.link;
          sa.target = '_self';
          submenu.appendChild(sa);
          sa.innerHTML = sm[lang];
        })
      }
    })

    //HAUNTED HOUSE MENU
    let panelBHauntedmenu = document.createElement('div');
    panelBHauntedmenu.className = `halloween-2025-panel-hauntedmenu halloween-2025-panel-submenu`;
    panelBHauntedmenu.setAttribute(':class',`{ 'halloween-2025-panel-submenuopen': hauntedOpen }`);
    // panelBHauntedmenu.setAttribute(':class',`{ 'halloween-2025-panel-submenuopen': true }`);
    
    panelB.appendChild(panelBHauntedmenu);
    let panelBHauntedmenuInner = document.createElement('div');
    panelBHauntedmenuInner.className = `halloween-2025-panel-submenu-inner`;
    panelBHauntedmenu.appendChild(panelBHauntedmenuInner);

    houseMenuArray.forEach((ele: any) => {
      let a = document.createElement('a');
      a.href = ele.link;
      panelBHauntedmenuInner.appendChild(a);

      let defaultImg = document.createElement('img');
      defaultImg.src = ele.img;
      defaultImg.alt = ele[lang];
      a.appendChild(defaultImg);

      let hoverImg = document.createElement('img');
      hoverImg.src = ele.imghover;
      hoverImg.className = 'halloween-2025-panel-hauntedmenu-hover';
      hoverImg.alt = ele[lang];
      a.appendChild(hoverImg);

      let span = document.createElement('span');
      span.textContent = ele[lang];
      a.appendChild(span);
    })

    //Day SUB MENU
    let panelBDaymenu = document.createElement('div');
    panelBDaymenu.className = `halloween-2025-panel-daymenu halloween-2025-panel-submenu`;
    panelBDaymenu.setAttribute(':class', `{ 'halloween-2025-panel-submenuopen': otherOpen }`)

    panelB.appendChild(panelBDaymenu);
    let panelBDaymenuInner = document.createElement('div');
    panelBDaymenuInner.className = `halloween-2025-panel-submenu-inner`;
    panelBDaymenu.appendChild(panelBDaymenuInner);

    let panelBDaymenuInnerList = document.createElement('div');
    panelBDaymenuInnerList.className = `halloween-2025-panel-submenu-list`;
    panelBDaymenuInner.appendChild(panelBDaymenuInnerList);

    otherMenuArray.forEach((ele: any) => {
      let a = document.createElement('a');
      a.href = ele.link;
      a.textContent = ele[lang];
      panelBDaymenuInnerList.appendChild(a);
    })

    //OTHERS SUB MENU
    // let panelBOthersmenu = document.createElement('div');
    // panelBOthersmenu.className = `halloween-2025-panel-othersmenu halloween-2025-panel-submenu`;
    // panelBOthersmenu.setAttribute(':class',`{ 'halloween-2025-panel-submenuopen': othersOpen }`)

    // panelB.appendChild(panelBOthersmenu);
    // let panelBOthersmenuInner = document.createElement('div');
    // panelBOthersmenuInner.className = `halloween-2025-panel-submenu-inner`;
    // panelBOthersmenu.appendChild(panelBOthersmenuInner);

    // let panelBOthersmenuInnerList = document.createElement('div');
    // panelBOthersmenuInnerList.className = `halloween-2025-panel-submenu-list`;
    // panelBOthersmenuInner.appendChild(panelBOthersmenuInnerList);

    // othersMenuArray.forEach((ele:any)=>{
    //   let a = document.createElement('a');
    //   a.href = ele.link;
    //   a.textContent = ele[lang];
    //   panelBOthersmenuInnerList.appendChild(a);
    // })
    

    //Panel Top Right
    let hamburgerHolder = document.createElement('div');
    hamburgerHolder.className = `halloween-2025-hamburger-holder`;
    hamburgerHolder.setAttribute('x-bind', `halloweenHamburger`);
    hamburgerHolder.innerHTML = `<button
      x-data="hamburgerComponent" 
      x-bind="hamburgerComponent"
      @click="hamburgerOpen=!hamburgerOpen"
      :class="{
        'halloween-2025-hamburger': true, 
        'halloween-2025-hamburger-active': hamburgerOpen 
      }"
    ></button>`;
    container?.appendChild(hamburgerHolder);
  }

  //Panel Top Right
  //hide for phase 1
  let panelTR = document.createElement('div');
  panelTR.className = `halloween-2025-panel-tr`;
  panelTR.setAttribute('x-bind', `halloweenBuyTicket`);
  let innerHTML = `<div 
		class="halloween-2025-panel-tr-inner" 
		x-data="ctaComponent" 
		x-bind="ctaComponent" :class="{ 'open': ctaOpen }" @mouseover="ctaOpen=true" @mouseout="ctaOpen=false">
      <div class="halloween-2025-ctatext-red">
        <button class="halloween-2025-panel-tr-action">${buyLabelText}</button>
        <div class="halloween-2025-panel-tr-detail">
          <a href="${ad_url}" target="_blank">${adLabelText}</a>
          <a href="${combo_url}" target="_blank">${comboLabelText}</a>
          <a href="${member_url}" target="_blank">${memberLabelText}</a>
        </div>
      </div>
    </div>`;
  panelTR.innerHTML = innerHTML;
  container?.appendChild(panelTR);

  // Countdown on Homepage only
  if (document.querySelector('.halloween-2025-index-container')){
    let countDownTR = document.createElement('div');
    countDownTR.className = `halloween-2025-countdown`;
    let countDownInnerHTML = `<div class="halloween-2025-countdown-title">${countdownLabelText}</div>
      <div
        class="halloween-2025-countdown-display"
        x-data="countdownComponent" 
        x-bind="countdownComponent"
      >
        <div class="halloween-2025-countdown-date" x-html="countdate"></div>
        <div class="halloween-2025-countdown-unit">${dayLabelText}</div>
      </div>`;
    countDownTR.innerHTML = countDownInnerHTML;
    container?.appendChild(countDownTR);

    //COUNTDOWN COMPONENT
    Alpine.data('countdownComponent', () => ({
      targetDate: new Date(),
      countdate: '',
      countdownComponent: {
        ['x-init']() {
          this.targetDate.setSeconds(0);
          this.targetDate.setMinutes(0);
          this.targetDate.setHours(0);
          this.targetDate.setDate(6);
          this.targetDate.setMonth(8);
          this.targetDate.setFullYear(2025);

          const _this = this;
          let itv:any = null;
          function updateDate() {
            let today: any = new Date();
            const td:any = _this.targetDate;
            const diffTime = td - today;
            const cd:any = document.querySelector('.halloween-2025-countdown');
            if(diffTime<=0){
              if(itv) clearInterval(itv);
              return;
            }else{
              cd.classList.add('incountdown');
            }
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            _this.countdate = String(diffDays);
          }

          updateDate();

          itv = setInterval(() => {
            updateDate();
          }, 1000)
        }
      },
    }));
  }

  //CTA COMPONENT
  Alpine.data('ctaComponent', () => ({
    ctaOpen: false,
    ctaComponent: {
      ['x-init']() {
        // console.log('menu');
      },
    }
  }));

  //HAMBURGER COMPONENT
  Alpine.data('hamburgerComponent', () => ({
    hamburgerOpen: false,
    hamburgerComponent: {
      ['x-init']() {
        // console.log('hamburgerOpen');
        this.$watch('hamburgerOpen', (value) => {
          if (value) {
            document.querySelector('.halloween-2025-panel-b')?.classList.add('menu-mobile-2024-on');
          } else {
            document.querySelector('.halloween-2025-panel-b')?.classList.remove('menu-mobile-2024-on');
          }
        });
      },
    }
  }));

}

const createHauntedHouseNav = () => {
  let container = document.querySelector('.halloween-2025-main-container');

  let houseNav = document.createElement('div');
  houseNav.className = `halloween-2025-haunted-house-nav`;
  container?.appendChild(houseNav);
  // let houseTitle = document.createElement('div');
  // houseTitle.className = `halloween-2025-haunted-house-nav-title halloween-2025-red-maintitle`;
  // houseTitle.textContent = houseMenuTitle[lang];
  // houseNav.appendChild(houseTitle);

  // let miniMapLegend = document.createElement('div');
  // miniMapLegend.className = `mobile-hallow-2024-miniMapLegend`;
  // houseNav.appendChild(miniMapLegend);

  // let miniMapLegendTabRed = document.createElement('div');
  // miniMapLegendTabRed.className = `mobile-hallow-2024-miniMapLegendTab legend-red`;
  // miniMapLegendTabRed.textContent = ticketLabel['walled'][lang];
  // miniMapLegend.appendChild(miniMapLegendTabRed);
  // let miniMapLegendTabGreen = document.createElement('div');
  // miniMapLegendTabGreen.className = `mobile-hallow-2024-miniMapLegendTab legend-green`;
  // miniMapLegendTabGreen.textContent = ticketLabel['ghostly'][lang];
  // miniMapLegend.appendChild(miniMapLegendTabGreen);

  let houseMenuUl = document.createElement('ul');
  houseNav.appendChild(houseMenuUl);

  houseMenuArray.forEach((ele) => {
    let li = document.createElement('li');
    houseMenuUl.appendChild(li);
    let a = document.createElement('a');
    a.href = ele.link;
    a.className = ele.class;
    a.textContent = ele[lang];
    li.appendChild(a);
  });

}

const createSocialShare = () => {
  let url = encodeURIComponent(window.location.href);
  let pageTitle = encodeURIComponent(document.title);

  let container = document.querySelector('.halloween-2025-main-container');

  let globalShare = document.createElement('div');
  globalShare.className = `halloween-global-share`;
  globalShare.setAttribute('x-data', 'shareComponent');
  globalShare.setAttribute('x-bind', 'globalShare');
  container?.appendChild(globalShare);

  let btnShare = document.createElement('div');
  btnShare.className = `btn-tool btn-share`;
  globalShare.appendChild(btnShare);

  let btnShareA = document.createElement('a');
  btnShareA.setAttribute('href', 'javascript:;');
  btnShareA.setAttribute('x-bind', 'triggerShareList');
  btnShare.appendChild(btnShareA);

  let btnShareASpan = document.createElement('span');
  btnShareA.appendChild(btnShareASpan);

  let shareIconBar = document.createElement('div');
  shareIconBar.className = `shareIconBar`;
  shareIconBar.setAttribute('x-bind', 'shareIconBar');
  globalShare.appendChild(shareIconBar);

  let shareIconBarInner = document.createElement('div');
  shareIconBarInner.className = `shareIconBarInner`;
  shareIconBar.appendChild(shareIconBarInner);

  //Buttons
  let shareFb = document.createElement('button');
  shareFb.className = `shareIcon fb`;
  shareFb.setAttribute('x-bind', 'shareFb');
  shareIconBarInner.appendChild(shareFb);
  let shareFbIcon = document.createElement('img');
  shareFbIcon.setAttribute('alt', '');
  shareFbIcon.setAttribute('src', 'https://www.oceanpark.com.hk/sites/all/themes/oceanpark/img/common/social_fb.png');
  shareFb.appendChild(shareFbIcon);

  let shareTw = document.createElement('button');
  shareTw.className = `shareIcon tw`;
  shareTw.setAttribute('x-bind', 'shareTw');
  shareIconBarInner.appendChild(shareTw);
  let shareTwIcon = document.createElement('img');
  shareTwIcon.setAttribute('alt', '');
  shareTwIcon.setAttribute('src', 'https://www.oceanpark.com.hk/sites/all/themes/oceanpark/img/common/social_tw.png');
  shareTw.appendChild(shareTwIcon);

  let shareLi = document.createElement('a');
  shareLi.className = `shareIcon li`;
  shareLi.setAttribute('target', '_blank');
  shareLi.setAttribute('href', `http://line.naver.jp/R/msg/text/?${url}`);
  shareIconBarInner.appendChild(shareLi);
  let shareLiIcon = document.createElement('img');
  shareLiIcon.setAttribute('alt', '');
  shareLiIcon.setAttribute('src', 'https://www.oceanpark.com.hk/sites/all/themes/oceanpark/img/common/social_li.png');
  shareLi.appendChild(shareLiIcon);

  let shareWs = document.createElement('a');
  shareWs.className = `shareIcon ws`;
  shareWs.setAttribute('target', '_blank');
  shareWs.setAttribute('href', `https://www.addtoany.com/add_to/whatsapp?linkurl=${url}`);
  shareIconBarInner.appendChild(shareWs);
  let shareWsIcon = document.createElement('img');
  shareWsIcon.setAttribute('alt', '');
  shareWsIcon.setAttribute('src', 'https://www.oceanpark.com.hk/sites/all/themes/oceanpark/img/common/social_ws.png');
  shareWs.appendChild(shareWsIcon);

  let shareTe = document.createElement('a');
  shareTe.className = `shareIcon te`;
  shareTe.setAttribute('target', '_blank');
  shareTe.setAttribute('href', `https://telegram.me/share/url?url=${url}`);
  shareIconBarInner.appendChild(shareTe);
  let shareTeIcon = document.createElement('img');
  shareTeIcon.setAttribute('alt', '');
  shareTeIcon.setAttribute('src', 'https://www.oceanpark.com.hk/sites/all/themes/oceanpark/img/common/social_te.png');
  shareTe.appendChild(shareTeIcon);

  let sharePr = document.createElement('button');
  sharePr.className = `shareIcon pr`;
  sharePr.setAttribute('x-bind', 'printIt');
  shareIconBarInner.appendChild(sharePr);
  let sharePrIcon = document.createElement('img');
  sharePrIcon.setAttribute('alt', '');
  sharePrIcon.setAttribute('src', 'https://www.oceanpark.com.hk/sites/all/themes/oceanpark/img/common/social_pr.png');
  sharePr.appendChild(sharePrIcon);

  let shareEm = document.createElement('a');
  shareEm.className = `shareIcon em`;
  shareEm.setAttribute('href', `mailto:?subject=${pageTitle}&body=${url}`);
  shareIconBarInner.appendChild(shareEm);
  let shareEmIcon = document.createElement('img');
  shareEmIcon.setAttribute('alt', '');
  shareEmIcon.setAttribute('src', 'https://www.oceanpark.com.hk/sites/all/themes/oceanpark/img/common/social_em.png');
  shareEm.appendChild(shareEmIcon);

  let shareFv = document.createElement('button');
  shareFv.className = `shareIcon fv`;
  shareFv.setAttribute('x-bind', 'bookmarkIt');
  shareIconBarInner.appendChild(shareFv);
  let shareFvIcon = document.createElement('img');
  shareFvIcon.setAttribute('alt', '');
  shareFvIcon.setAttribute('src', 'https://www.oceanpark.com.hk/sites/all/themes/oceanpark/img/common/social_fv.png');
  shareFv.appendChild(shareFvIcon);

}

const shareInit = () => {
  // console.log('customSelectInit')
  Alpine.data('shareComponent', () => ({
    show: false,
    hover: false,
    url: encodeURIComponent(window.location.href),
    triggerShareList: {
      // ['@click']() {
      //   this.show = !this.show;
      // },
      // ['@click.outside']() {
      //   this.show = false;
      // }
    },
    shareIconBar: {
      // [":class"]() {
      //   return { "open": this.show, "over": this.hover };
      // },
      // ['@mouseover']() {
      //   this.hover = true;
      // },
      // ['@mouseout']() {
      //   this.hover = false;
      // }
    },
    shareFb: {
      // ['@click']() {
      //   this.shareToFB();
      // },
    },
    shareTw: {
      // ['@click']() {
      //   this.shareToTwitter();
      // },
    },
    printIt: {
      // ['@click']() {
      //   this.sharePrintIt();
      // },
    },
    bookmarkIt: {
      // ['@click']() {
      //   this.shareBookmarkIt();
      // },
    },
    shareToFB() {
      var url = 'https://www.facebook.com/sharer/sharer.php?u=' + this.url;
      window.open(url, 'cssSocialMediaPopup', 'menubar=1,resizable=1,width=500,height=250');
      return false;
    },
    shareToTwitter() {
      var url = 'https://twitter.com/intent/tweet?url=' + this.url;
      window.open(url, 'cssSocialMediaPopup', 'menubar=1,resizable=1,width=500,height=250');
      return false;
    },
    sharePrintIt() {
      window.print();
    },
    shareBookmarkIt() {
      var title = 'Ocean Park';
      var url = this.url;
      if (document.all) { // ie
        window.external.AddFavorite(url, title);
      }
      else if (window.sidebar) { // firefox
        window.sidebar.addPanel(title, url, "");
      }
      else if (window.opera && window.print) { // opera
        var elem = document.createElement('a');
        elem.setAttribute('href', url);
        elem.setAttribute('title', title);
        elem.setAttribute('rel', 'sidebar');
        elem.click(); // this.title=document.title;
      } else { // webkit - safari/chrome
        alert('Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') != - 1 ? 'Command/Cmd' : 'CTRL') + ' + D to bookmark this page.');
      }
    },
  }));
}

const createMusicButton = () => {
  let container = document.querySelector('.halloween-2025-main-container');

  let hwMusic = document.createElement('div');
  hwMusic.className = `halloween-music`;
  hwMusic.setAttribute('x-data', 'musicComponent');
  hwMusic.setAttribute('x-bind', 'musicComponent');
  container?.appendChild(hwMusic);

  let hwAudio = document.createElement('audio');
  hwAudio.setAttribute('x-ref', 'halloweenAudio');
  hwAudio.setAttribute('x-bind', 'halloweenAudio');
  hwAudio.id = `halloween-audio`;
  hwAudio.hidden = true;
  hwAudio.loop = true;
  hwMusic.appendChild(hwAudio);

  let hwAudioSrc = document.createElement('source');
  hwAudioSrc.type = 'audio/mp3';
  hwAudioSrc.src = 'https://media.oceanpark.com.hk/files/s3fs-public/halloween2025/halloween-2025-bgm.mp3';
  hwAudio.appendChild(hwAudioSrc);

  let hwButton = document.createElement('button');
  hwButton.setAttribute('x-bind', 'musicControl');
  hwMusic.appendChild(hwButton);

  let hwButtonSpan = document.createElement('span');
  hwButton.appendChild(hwButtonSpan);
}

const musicInit = () => {
  // console.log('musicComponent')
  Alpine.data('musicComponent', () => ({
    // playMusic:false,
    store: globalStore,
    hideNav: false,
    musicComponent: {
      ['x-init']() {
        // @ts-ignore
        this.store = (this.$store as HomeStore).global;
        // console.log('this.store', this.store)
        this.$watch('this.store', (value, oldValue) => console.log(value, oldValue));
        this.store.playMusic ? this.$refs.halloweenAudio.play() : this.$refs.halloweenAudio.pause();
      },
      ['@scroll.window']() {
        const rect = document.querySelector('.halloween-2025-main-container')?.getBoundingClientRect();
        const viewportHeight = globalThis.innerHeight || document.documentElement.clientHeight;
        this.hideNav = (rect.bottom <= viewportHeight);

      },
      [":class"]() {
        // console.log('this.store.playMusic class', this.store.playMusic)
        return { 
          "play": this.store.playMusic,
          "halloween-hide": this.hideNav
         };
      },
    },
    halloweenAudio: {
      ['@set-play-music.window']() {
        // console.log("this.$event.detail.playMusic", this.$event.detail.playMusic)
        this.store.playMusic = this.$event.detail.playMusic;
        this.store.playMusic ? this.$el.play() : this.$el.pause();
      },
    },
    musicControl: {
      ['x-init']() {
      },
      ['@click']() {
        this.store.playMusic = !this.store.playMusic;
        // this.playMusic = this.store.playMusic;
        this.store.playMusic ? this.$refs.halloweenAudio.play() : this.$refs.halloweenAudio.pause();
      }
    },
  }));
}

const mainContainerInit = () => {
  // console.log('customSelectInit')
  Alpine.data('halloweenMainContainer', () => ({
    hideNav: false,
    halloweenMainContainer: {
      ['@scroll.window']() {
        const rect = this.$el.getBoundingClientRect();
        const viewportHeight = globalThis.innerHeight || document.documentElement.clientHeight;
        this.hideNav = (rect.bottom <= viewportHeight);

      },
    },
    halloweenMainNav: {
      [":class"]() {
        return { "halloween-hide": this.hideNav };
      }
    },
    halloweenHamburger: {
      [":class"]() {
        return { "halloween-hide": this.hideNav };
      }
    },
    halloweenBuyTicket: {
      [":class"]() {
        return { "halloween-hide": this.hideNav };
      }
    },
    globalShare: {
      [":class"]() {
        return { "halloween-hide": this.hideNav };
      }
    },
    
  }));
}

export {
  findElementIndex,
  getBreakpoint,
  globalStore,
  getOffset,
  createHauntedHouseNav
}

document.addEventListener('alpine:init', () => {
  createSocialShare();
  //hide for phase 1
  createMusicButton();
  createPanel();
  shareInit();
  musicInit();
  mainContainerInit();
})